export const styles = () => ({
  paper: {
    height: '33.1rem',
    width: '35.6rem',
    borderRadius: '4px',
    margin: 'auto',
  },
  backToLogInBtn: {
    display: 'inline',
    marginRight: '1.87rem',
  },
  sendEmailBtn: {
    padding: '0 1.87rem',
  },
  fgLoginButton: {
    flexDirection: 'row-reverse',
  },
  spinner: {
    position: 'absolute',
    top: '40%',
    left: '50%',
  },
});
